export default __webpack_public_path__ + "static/8-e8399da78a770b7241a7fbbad7c05aeb.png";